import { INavData } from "@coreui/angular";
import { ROLE_RESOURCE_PERMISSIONS } from "src/constants/constants";
// import { PERMISSIONS } from "src/constants/constants";

export const navItems: INavData[] = [
  {
    name: "Dashboard",
    class: ROLE_RESOURCE_PERMISSIONS.DASHBOARD,
    url: "admin/dashboard",
  },
  {
    name: "Competitions",
    class: ROLE_RESOURCE_PERMISSIONS.COMPETITIONS,
    url: "admin/competitions/list",
    icon: "assets/images/trophy.svg",
  },
  {
    name: "Content Management",
    icon: "assets/images/contentView.svg",
    children: [
      {
        name: "About Us",
        url: "/admin/content/about_us",
        class: ROLE_RESOURCE_PERMISSIONS.ABOUT_US,
      },
      {
        name: "FAQ",
        url: "/admin/content/faq",
        class: ROLE_RESOURCE_PERMISSIONS.FAQ,
      },
      {
        name: "T&C",
        url: "/admin/content/terms_and_conditions/versions",
        class: ROLE_RESOURCE_PERMISSIONS.TERMS_AND_CONDITIONS,
      },
      // {
      //   name: "Org T&C",
      //   url: "/admin/content/org_terms_and_conditions",
      // },
      // {
      //   name: "Individual T&C",
      //   url: "/admin/content/individual_terms_and_conditions",
      // },
      {
        name: "Privacy Policy",
        url: "/admin/content/privacy_policy/versions",
        class: ROLE_RESOURCE_PERMISSIONS.PRIVACY_POLICY,
      },
      {
        name: "User Manuals",
        url: "/admin/content/user_manuals",
        class: ROLE_RESOURCE_PERMISSIONS.USER_MANUALS,
      },
      {
        name: "Articles",
        url: "/admin/content/article",
        class: ROLE_RESOURCE_PERMISSIONS.ARTICLES,
      },
      {
        name: "Maintenance",
        url: "admin/content/maintenance",
        class: ROLE_RESOURCE_PERMISSIONS.MAINTENANCE,
      },
      {
        name: "Master Data",
        url: "admin/master-data/list",
        class: ROLE_RESOURCE_PERMISSIONS.MASTER_DATA,
      },
      {
        name: "Banners",
        url: "admin/banners/list",
        class: ROLE_RESOURCE_PERMISSIONS.BANNERS,
      },
      {
        name: "Metadata Standards",
        url: "admin/content/metadata_standards",
        class: ROLE_RESOURCE_PERMISSIONS.METADATA_CONTENT,
      },
      {
        name: "Notebook Content",
        url: "admin/content/notebook_content",
        class: ROLE_RESOURCE_PERMISSIONS.NOTEBOOK_CONTENT,
      },
      {
        name: "Promotional Emails",
        url: "admin/promotional-emails/list",
        class: ROLE_RESOURCE_PERMISSIONS.PROMOTIONAL_EMAILS,
      }
    ],
  },
  {
    name: "Role Management",
    icon: "assets/images/person_outline.svg",
    children: [
      {
        name: "Roles",
        url: "admin/roleManagement/list/master/roles",
        class: ROLE_RESOURCE_PERMISSIONS.ROLES,
      },
      {
        name: "Resources",
        url: "admin/roleManagement/list/master/resource",
        class: ROLE_RESOURCE_PERMISSIONS.RESOURCES,
      },
      {
        name: "Actions",
        url: "admin/roleManagement/list/master/action",
        class: ROLE_RESOURCE_PERMISSIONS.ACTIONS,
      },
      {
        name: "Permission",
        url: "admin/roleManagement/list/permission",
        class: ROLE_RESOURCE_PERMISSIONS.PERMISSION,
      },
      {
        name: "Role Permissions",
        url: "admin/roleManagement/list/rolePermission",
        class: ROLE_RESOURCE_PERMISSIONS.ROLE_PERMISSIONS,
      },
    ],
  },
  {
    name: "Organization Approval",
    class: ROLE_RESOURCE_PERMISSIONS.ORG_APPROVAL,
    url: "admin/org-approval/list",
    icon: "assets/images/approvals-app.svg",
    badge: {
      text: "",
      color: "#fff",
    },
  },
  {
    name: "Manage Approvals",
    icon: "assets/images/approvals-app.svg",
    children: [
      {
        class: ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
        name: "Artefact Approval",
        url: "admin/artefact/artefact-approvals",
        badge: {
          text: "",
          color: "#fff",
        },
      },
      {
        class: ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS_VERSION,
        name: "Version Approval",
        url: "admin/artefact/artefact-approvals-version",
      },
    ],
  },
  {
    name: "Organizations",
    class: ROLE_RESOURCE_PERMISSIONS.ORGANISATION,
    url: "admin/organisation/list",
    icon: "assets/images/Building.svg",
  },
  {
    name: "Users",
    url: "admin/user/list",
    class: ROLE_RESOURCE_PERMISSIONS.USERS,
    icon: "assets/images/person_outline.svg",
  },
  {
    name: "Artefacts",
    icon: "assets/images/Ribbon.svg",
    url: "admin/artefact/artefact-list",
    class: ROLE_RESOURCE_PERMISSIONS.ARTEFACTS,
  },
  // {
  //   name: "Sector & Themes",
  //   icon: "assets/images/sectors&themes.svg",
  //   url: "admin/master-data/sectors/list/Sectors",
  //   class: ROLE_RESOURCE_PERMISSIONS.SECTOR_THEME,
  // },
  // {
  //   name: "Datasets",
  //   url: "admin/artefact/artefact-list",
  //   class: PERMISSIONS.DATASETS,
  //   icon: 'assets/images/Database.svg'
  // },
  // {
  //   name: "Models",
  //   url: "admin/models/list",
  //   class: PERMISSIONS.MODELS,
  //   icon: 'assets/images/modelBox.svg'
  // },
  // {
  //   name: "Use Case",
  //   class: PERMISSIONS.USE_CASE,
  //   url: "admin/use-case/list",
  //   icon: 'assets/images/Toolbox.svg'
  // },
  {
    name: "Toolkit Management",
    url: "admin/toolkits/list",
    class: ROLE_RESOURCE_PERMISSIONS.TOOLKIT_MANAGEMENT,
    icon: "assets/images/contentView.svg",
  },
  {
    name: "Notebook",
    url: "admin/notebook/notebook-list",
    class: ROLE_RESOURCE_PERMISSIONS.COMPUTE_NOTEBOOK,
    icon: "assets/images/angle-brackets.svg",
  },
  {
    name: "Tutorials",
    class: ROLE_RESOURCE_PERMISSIONS.TUTORIALS,
    url: "admin/resources/list",
    icon: "assets/images/contentView.svg",
  },
  // {
  //   name: "Master Data",
  //   url: "admin/master-data/list",
  //   class: PERMISSIONS.MASTER_DATA,
  //   icon: "assets/images/contentView.svg",
  // },
  // {
  //   name: "System Params",
  //   url: "admin/system-params/list",
  //   class: PERMISSIONS.SYSTEM_PARAMS,
  //   icon: "assets/images/contentView.svg",
  // },
  // {
  //   name: "Banners",
  //   url: "admin/banners/list",
  //   class: PERMISSIONS.BANNER_IMAGE,
  //   icon: "assets/images/contentView.svg",
  // },

  {
    name: "Manage Grievances",
    url: "admin/manage-grievances",
    icon: "assets/images/contentView.svg",
    class: ROLE_RESOURCE_PERMISSIONS.MANAGE_GRIEVANCES,
    badge: {
      text: "",
      color: "#fff",
    },
  },
  {
    name: "Feedback Management",
    url: "admin/feedback-management",
    icon: "assets/images/contentView.svg",
    class: ROLE_RESOURCE_PERMISSIONS.FEEDBACK_MANAGEMENT,
  },
  {
    name: "Manage Team Roles",
    url: "admin/teams/manage-roles",
    icon: "assets/images/teams.svg",
    class: ROLE_RESOURCE_PERMISSIONS.MANAGE_TEAM_ROLES,
  },
];
